import { AppDispatch, AppState } from "@/store/configureStore";
import axios from "axios";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { createCart, addCartItem } from "@/store/slices/cartSlice";
import useRemoveDiscountIfNeeded from "./useRemoveDiscountIfNeeded";

const useAddToCart = () => {
	const base_url = process.env.NEXT_PUBLIC_BASE_URL;
	const dispatch = useDispatch<AppDispatch>();
	const cart = useSelector((state: AppState) => state.cart);
	const removeDiscountIfNeeded = useRemoveDiscountIfNeeded();
	const createNewCart = async () => {
		try {
			const response = await axios.post(`${base_url}/api/cart/create`);
			dispatch(
				createCart({
					id: response?.data?.cart?.id,
					totalPrice: response?.data?.cart?.totalPrice,
					discountedPrice: response?.data?.cart?.discountedPrice,
					owner: response?.data?.cart?.owner,
				})
			);
			return response?.data?.cart?.id;
		} catch (error: string | any) {
			// console.log(error);
			toast.remove();
			toast.error(error.response?.data?.error);
			return;
		}
	};
	const addToCart = async (productId: string | undefined) => {
		try {
			await removeDiscountIfNeeded();
			const cartId = cart.id || (await createNewCart());
			const response = await axios.put(`${base_url}/api/cart/add/${productId}`, {
				cartId: cartId,
			});

			dispatch(
				addCartItem({
					id: response?.data?.cart?.id,
					totalPrice: response?.data?.cart?.totalPrice,
					discountedPrice: response?.data?.cart?.discountedPrice,
					items: response?.data?.cart?.items,
				})
			);
			// toast.success(response?.data.msg);
		} catch (error: string | any) {
			toast.remove();
			toast.error(error.response?.data?.error);
		}
	};

	const quantityAddToCart = async (
		productId: string | undefined,
		quantity: number | undefined
	) => {
		try {
			await removeDiscountIfNeeded();
			// console.log(productId, cart.id, quantity);

			const cartId = cart.id || (await createNewCart());
			const response = await axios.put(
				`${base_url}/api/cart/product/${productId}/update-quantity`,
				{
					cartId: cartId,
					quantity: quantity,
				}
			);
			// console.log(response);

			dispatch(
				addCartItem({
					id: response?.data?.result?.id,
					totalPrice: response?.data?.result?.totalPrice,
					discountedPrice: response?.data?.result?.discountedPrice,
					items: response?.data?.result?.items,
				})
			);
			// toast.success(response?.data.msg);
		} catch (error: string | any) {
			// console.log(error);
			toast.remove();
			toast.error(error.response?.data?.error);
		}
	};

	// const groupQuantityAddToCart = async (productId: string | undefined, quantity:number | undefined) => {
	// 	try {
	// 		const cartId = cart.id || (await createNewCart());
	// 		const response = await axios.put(`${base_url}/api/cart/product/${productId}/update-quantity`, {
	// 			cartId: cartId,
	// 			quantity: quantity,
	// 		});
	//        // console.log(response);

	// 		dispatch(
	// 			addCartItem({
	// 				id: response?.data?.cart?.id,
	// 				totalPrice: response?.data?.cart?.totalPrice,
	// 				discountedPrice: response?.data?.cart?.discountedPrice,
	// 				items: response?.data?.cart?.items,
	// 			})
	// 		);
	// 		// toast.success(response?.data.msg);
	// 	} catch (error: string | any) {
	// 		toast.error(error.response?.data?.error);
	// 	}
	// };

	return {
		addToCart,
		quantityAddToCart,
	};
};

export default useAddToCart;
